var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonConverter, JsonElementType, JsonObject, JsonProperty, propertyConverters, } from 'ta-json-x';
import { JsonStringConverter } from '../../converters/string-converter';
import { JsonThingConverter } from './converters/thing-json-converter';
import { Thing } from './thing';
let Contributor = class Contributor extends Thing {
};
__decorate([
    JsonConverter(JsonStringConverter),
    JsonProperty('role'),
    JsonElementType(String),
    __metadata("design:type", Array)
], Contributor.prototype, "role", void 0);
Contributor = __decorate([
    JsonObject()
], Contributor);
export { Contributor };
propertyConverters.set(Contributor, new JsonThingConverter(Contributor));
//# sourceMappingURL=contributor.js.map